import { render, staticRenderFns } from "./DeleteConfirmModal.vue?vue&type=template&id=0d5d08ec&scoped=true&"
import script from "./DeleteConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d08ec",
  null
  
)

export default component.exports